import { Navigate } from 'react-router-dom';
import { useFolderContext } from '~/contexts';

export const ContentRootRedirect = () => {
  const { landingFolderId } = useFolderContext();

  return <Navigate replace to={`${landingFolderId}`} />;
};
